var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"thumb-list"},_vm._l((_vm.items),function(item,index){return _c('div',{key:'list_item__' + index,staticClass:"list-item"},[_c('pdfShow',{attrs:{"width":"60px","height":"60px","items":_vm.items,"img":item,"pdfScale":_vm.pdfScale,"listType":_vm.listType}})],1)}),0):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }